import Cleave from 'cleave.js'

export default class Reservation {
    static init(){
                
        const reservationBlock = document.getElementById('reservation-block');
        if(reservationBlock) {
            const isDesktop = window.outerWidth > 767;

            if(isDesktop) {
                reservationBlock.parentNode.style.height = reservationBlock.parentNode.offsetHeight + 'px';
            }
            const trigger = document.querySelector('[data-scroll-to-reservation-block]');
            const offsetTop = reservationBlock.parentNode.offsetTop + reservationBlock.parentNode.offsetHeight;
            let isFixed = false;

            window.addEventListener('scroll', _.throttle(() => {
                if(window.scrollY > offsetTop) {
                if(!isFixed) {
                    if(isDesktop) {
                    document.body.style.paddingBottom = reservationBlock.offsetHeight + 'px'
                    reservationBlock.classList.add('is-fixed')
                    } else {
                    if(trigger) document.body.style.paddingBottom = trigger.parentNode.offsetHeight + 'px'
                    }
                    document.body.classList.add('reservation-block-is-fixed')
                    isFixed = true
                }
                } else {
                if(isFixed) {
                    if(isDesktop) {
                        reservationBlock.classList.remove('is-fixed')
                    }
                    document.body.style.removeProperty('padding-bottom')
                    document.body.classList.remove('reservation-block-is-fixed')
                    isFixed = false
                }
                }
            }, 150));

            if(!isDesktop) {
                if(trigger) {
                    setTimeout(() => {
                        trigger.parentNode.classList.add('enabled')
                    }, 2e3);
                    trigger.addEventListener('click', (e) => {
                        window.scroll(0, reservationBlock.offsetTop - 20)
                    })
                }
            }
        }

        /*
        const initializeSingleCheckboxes = () =>
        {
        console.log('initializeSingleCheckboxes')
        const checkboxes = document.querySelectorAll('[data-single-checkbox]')
        checkboxes.forEach(function(item){
            if(item.classList.contains('is-sc-initialized')) return;

            const id = item.dataset.singleCheckbox;
            item.classList.add('is-sc-initialized')
            item.addEventListener('change', (e) => {
            if(item.checked) {
                const others = document.querySelectorAll('[data-single-checkbox='+id+']');
                others.forEach(function(otherItem){
                otherItem.checked = false
                })
            }
            })
        })
        }
        initializeSingleCheckboxes()


        Livewire.hook('element.updated', (el, component) => {
        initializeSingleCheckboxes()
        })
        */

        window.addEventListener('display-credit-card-form', (e) => {
            if(document.getElementById('cc-number')) {
                const cleaveCcNumber = new Cleave('#cc-number', {
                    creditCard: true
                })
            }
            if(document.getElementById('cc-expiry')) {
                const cleaveCcExpiry = new Cleave('#cc-expiry', {
                    date: true,
                    delimiter: '/',
                    datePattern: ['m','y']
                });
            }
        })

        window.addEventListener('page-scrolltop', (e) => {
            window.scroll(0, document.querySelector('[data-scroll-pagetop]').offsetTop)
        })

        if(document.getElementById('cc-number') || document.getElementById('cc-expiry')) {
            window.dispatchEvent( new CustomEvent('display-credit-card-form') )
        }
    }
}